"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUserLocaleExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../services"));
const updateUserLocale = toolkitRaw.createAsyncThunk('user/update_user_locale', async ({ language, bearerToken, idToken }, { rejectWithValue }) => {
    try {
        const headers = {
            Authorization: `Bearer ${String(bearerToken)}`,
            'Auth0-IdToken': idToken,
        };
        services_1.default.patch('/api/me', {
            data: {
                type: 'user',
                attributes: {
                    locale: language,
                },
            },
        }, {
            headers,
        });
        return language;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const updateUserLocaleExtraReducers = (builder) => {
    builder.addCase(updateUserLocale.fulfilled, (state, action) => {
        if (state.data) {
            state.data.language = action.payload;
        }
    });
};
exports.updateUserLocaleExtraReducers = updateUserLocaleExtraReducers;
exports.default = updateUserLocale;
//# sourceMappingURL=index.js.map